import React, { useState, useEffect, useRef } from 'react';
import styles from './LoanContact.scss';
// import DatePicker from '../DatePicker';
import ButtonRound from '../ButtonRound';
import { ILoanRequestAddSubmit, ILoanRequestUserData } from '../../utils/LoanRequest';
import Markdown from '../Markdown';
import Config from '../../utils/Config';
import useUser from '../../stores/useUser';
import { ILoanCalculatorTextKeys } from './LoanCalculatorPage';
import { alert } from '../AsyncModal';
import TextField from '../MaterialUi/TextField';
// import Checkbox from '../Checkbox';
import Checkbox from '../MaterialUi/Checkbox';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Select from '../MaterialUi/Select';
import { IOccupation, occupationList, timeList, usageList } from './LoanUserDetails';
import SyncFixedBottom from '../SyncFixedBottom';
import Responsive from '../../utils/Responsive';
import AccedoSvg from '../../assets/img/logo_accedo.svg';

export interface ILoanContactProps {
    onNextStep: (data: any) => void;
    onPreviousStep: () => void;
    // data: ILoanRequestUserData & { birthday?: string };
    data: ILoanRequestAddSubmit;
    textKeys?: ILoanCalculatorTextKeys['step4'];
    syncRef: React.RefObject<HTMLDivElement>;
}

export interface ILoanDetails {
    occupation?: IOccupation | '';
    usage?: keyof typeof usageList | '';
    time?: keyof typeof timeList | '';
}

const LoanContact: React.FC<React.PropsWithChildren<ILoanContactProps>> = ({ data = null, textKeys = null, onNextStep = () => {}, onPreviousStep = () => {}, syncRef }) => {
    const [user] = useUser();
    const [userData, setUserData] = React.useState<ILoanRequestUserData & { birthday?: string }>(user);

    const [loanDetails, setLoanDetails] = React.useState<ILoanDetails>({
        occupation: data?.loanDetails?.occupation ? data.loanDetails.occupation : '',
        usage: data?.loanDetails?.usage ? data.loanDetails.usage : '',
        time: data?.loanDetails?.time ? data.loanDetails.time : '',
    });

    React.useEffect(() => {
        // userActions.getStatus().then((data) => {
        setUserData(user);
        // });
    }, [user]);

    const handleChange = (ev: React.FormEvent) => {
        const elm = ev.currentTarget as HTMLInputElement;
        setUserData({ ...userData, [elm.name]: elm.value });
    };

    // const handleValueChange = (name: string, value: string | number) => {
    //     // value = typeof value === 'string' ? parseInt(value) : value;
    //     setUserData({ ...userData, [name]: value });
    // };

    const handleNextStep = (ev: React.FormEvent) => {
        ev.preventDefault();

        if (userData.phone || userData.mail) {
            onNextStep({
                userData: { ...userData },
                loanDetails: { ...loanDetails },
            });
        } else {
            alert(<p>Gib bitte Deine Telefonnummer oder E-Mail an, damit wir Dich kontaktieren können.</p>);
        }
    };

    const handleCheckboxChange = (ev: any) => {
        const target = ev.target as HTMLInputElement;
        setUserData({ ...userData, [target.name]: target.checked });
    };

    const handleLoanDetailsChange = (ev) => {
        const target = ev.target;
        const name = target.name;
        const value = target.value;
        setLoanDetails({ ...loanDetails, [name]: value });
    };

    const dataProcessingAlreadyAccepted = user?.dataProcessingAccepted;

    return (
        <div className={styles.loanContact}>
            <form onSubmit={handleNextStep}>
                <div className={styles.box}>
                    <div className={styles.fields}>
                        <div className={styles.name}>
                            <TextField name="given_name" value={userData.given_name || ''} onChange={handleChange} label="Vorname" required={true} />
                        </div>
                        <div className={styles.name}>
                            <TextField name="family_name" value={userData.family_name || ''} onChange={handleChange} label="Nachname" required={true} />
                        </div>
                        <div className={styles.wide}>
                            <TextField name="phone" type={'tel'} value={userData.phone || ''} onChange={handleChange} label="Telefon" />
                        </div>
                        <div className={styles.wide}>
                            <TextField name="mail" type={'email'} value={userData.mail || ''} onChange={handleChange} label="E-Mail" />
                        </div>

                        {/* <div className={styles.wide}>
                            <Select
                                // className={styles.select}
                                label="Beschäftigungsverhältnis"
                                value={loanDetails.occupation}
                                name="occupation"
                                onChange={handleLoanDetailsChange}
                            >
                                {Object.keys(occupationList).map((key) => {
                                    const val = occupationList[key];
                                    return (
                                        <option key={val} value={key}>
                                            {val}
                                        </option>
                                    );
                                })}
                            </Select>
                        </div> */}
                        {/* <div className={styles.wide}>
                            <Select
                                // className={styles.select}
                                label="Geplante Nutzung"
                                value={loanDetails.usage}
                                name="usage"
                                onChange={handleLoanDetailsChange}
                                // label={textKeys.labels.usage}
                            >
                                {Object.keys(usageList).map((key) => {
                                    const val = usageList[key];
                                    return (
                                        <option key={val} value={key}>
                                            {val}
                                        </option>
                                    );
                                })}
                            </Select>
                        </div> */}
                        {/* <div className={styles.wide}>
                            <Select
                                // className={styles.select}
                                label="Wann soll finanziert werden?"
                                value={loanDetails.time.toString()}
                                name="time"
                                onChange={handleLoanDetailsChange}
                                // label={textKeys.labels.time}
                            >
                                {Object.keys(timeList).map((key) => {
                                    const val = timeList[key];
                                    return (
                                        <option key={val} value={key}>
                                            {val}
                                        </option>
                                    );
                                })}
                            </Select>
                        </div> */}
                    </div>
                    {/* </div> */}

                    {!dataProcessingAlreadyAccepted && (
                        <div className={styles.dataProcessingContainer}>
                            <div className={styles.checkbox}>
                                <Checkbox
                                    required={true}
                                    value={userData.dataProcessingAccepted ? true : false}
                                    // value="acceptTerms"
                                    name="dataProcessingAccepted"
                                    label=""
                                    onChange={handleCheckboxChange}
                                />
                                {/* <Checkbox
                                    required={true}
                                    checked={userData.dataProcessingAccepted ? true : false}
                                    value="acceptTerms"
                                    name="dataProcessingAccepted"
                                    label=""
                                    onChange={handleCheckboxChange}
                                /> */}
                            </div>
                            <Markdown linkTarget="_blank" className={styles.dataProcessing}>
                                {Config.get('loanContact.dataProcessing')}
                            </Markdown>
                        </div>
                    )}

                    <div className={styles.actions}>
                        <ButtonRound onClick={onPreviousStep} variant="outlined" icon={<ChevronLeftIcon />} className={styles.back}>
                            zurück
                        </ButtonRound>
                        <ButtonRound type="submit">{textKeys?.button}</ButtonRound>
                    </div>
                </div>
            </form>

            <SyncFixedBottom
                className={styles.partner}
                syncWith={syncRef}
                topOffset={65}
                bottomOffset={45}
                active={Responsive.getWidth() >= 993}
                alignment="bottom"
            >
                <div>
                    <AccedoSvg />
                    <h2>Ihre Baufinanzierung: Individuell. Fair. Kostenfrei.</h2>
                    <p>
                        Ihr maßgeschneidertes Baufinanzierungskonzept vom Service-Sieger. Mit persönlicher Beratung Ihres{' '}
                        <span className={styles.accedo}>accedo</span>-Baufinanzierungsexperten.
                    </p>
                </div>
            </SyncFixedBottom>
        </div>
    );
};

export default LoanContact;
